import { Component, ElementRef, forwardRef, Input, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-checkbox-component',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ],
})
export class CheckboxComponent implements ControlValueAccessor {
  @Input() title: string;
  @Input() labelColor: string;
  @ViewChild('input') input: ElementRef;

  private propagateChange = (_: any): void => { };

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  private propagateTouch = (_: any): void => { };

  registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }

  writeValue(value: boolean): void {
    this.input.nativeElement.checked = value;
  }

  onClick(): void {
    this.propagateChange(this.input.nativeElement.checked);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/components/CheckboxComponent/checkbox.component.ts